'use client'
import { Icon, Popover } from '@circlefin/components'
import { useScrollDirection } from '@features/common.hooks/useScrollDirection'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import {
  TABLE_OF_CONTENTS_WRAPPER_ID,
  TableOfContents,
} from './TableOfContents'

export const TableOfContentsPopover = () => {
  const scrollDirection = useScrollDirection()
  const { t } = useTranslation('common')

  // Determine the correct top placement class based on scroll direction and header behavior
  const topPlacementClass =
    scrollDirection === 'DOWN'
      ? 'top-0 md:top-header' // This logic applies when the header attempts to hide (on small screens) or scroll has occurred
      : 'top-header' // Default state: initial load (header visible) or scrolling UP (header visible)

  return (
    <div
      className={classNames(
        'fixed right-8 z-20 pt-6 xl:hidden transition-all duration-500',
        topPlacementClass,
      )}
      data-testid="toc-popover-container"
    >
      <Popover alignment="end">
        <div className="rounded-sm border border-neutral-subtle bg-white shadow-sm">
          <Popover.IconButton
            aria-label={t('tableOfContents.popoverLabel')}
            // this is to hide the Open popover text
            label=""
            popupRole="tree"
            size="sm"
          >
            <Icon className="size-5" name="MenuAlt2Outline" />
          </Popover.IconButton>
        </div>
        <Popover.Panel className="max-h-[calc(100vh-12.5rem)] w-58 overflow-y-auto">
          <TableOfContents wrapperId={TABLE_OF_CONTENTS_WRAPPER_ID} />
        </Popover.Panel>
      </Popover>
    </div>
  )
}
